import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Redo = (props) => (
  <Icon viewBox="0 0 15 15" {...props}>
    <g>
      <path d="M15.047 7.026l-3.85 3.751-3.848-3.75.965-.717 2.917 2.583V5.886C11.23 3.237 8.94 1 6.23 1s-5 2.237-5 4.886v8.783h-1V5.886C.23 2.64 2.92 0 6.23 0c3.309 0 6 2.64 6 5.886v3.007l2.384-2.583.432.716z"
        fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Redo;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Redo.js